import Vue from "vue";
import Vuex from "vuex";
import { getSimpleList } from "@/api/enum";
import { groupBy } from "@/libs/utils";
import storage from "@/libs/storage";
// import axios from "@/libs/api.request";

const ENUM_KEY = "ENUM_CACHE";

const _enums = storage.getSession(ENUM_KEY) || {};

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    AllEnums: _enums,
    relationList: [],
  },
  mutations: {
    setRelationList(state, data) {
      state.relationList = data;
    },
  },
  actions: {
    async getSimpleList({ state }) {
      let res = await getSimpleList();
      let _enums = groupBy(res.data, "dictType", true);
      state.AllEnums = _enums;
      storage.setSession(ENUM_KEY, _enums);
    },
  },
  modules: {},
});
